import {Component} from '@angular/core';
import {CdkAccordionModule} from '@angular/cdk/accordion';

/**
 * User profile info UI
 * This component works along with epg-user-menu-navigation and epg-user-menu-navigation-fullscreen.
 * This component displays the user information.
 *
 * @example
 *
 * <epg-user-profile-info>
      <h2>Smith, Robert</h2>
      <p class="email">robert.smithpartena.be</p>
    </epg-user-profile-info>
 */
@Component({
  selector: 'epg-user-profile-info',
  imports: [CdkAccordionModule],
  template: `<ng-content/>`,
})
export class EpgUserProfileInfoComponent {}
